<template>
<div>

    <div v-if=showgraph>
        <plottraffic :key=myKey chartId="traffic" class="chart-wrapper" style="height:250px;margin-bottom:10px;" :interface=this.interface :device=device :period=period :deviceID="this.deviceID"></plottraffic>
    </div>
    <div v-if=showtable>
        <tabulatetraffic :key=myKey class="chart-wrapper" style="margin-top:10px;" :interface=this.interface :device=device :period=period :deviceID="this.deviceID"></tabulatetraffic>
    </div>

    <b-button type="button" :pressed.sync="showtable" variant="outline-primary" class="float-right"><i class="icon-grid"></i></b-button>
    <b-button type="button" :pressed.sync="showgraph" variant="outline-primary" class="float-right"><i class="icon-graph"></i></b-button>
    <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
        <b-form-radio-group class="mr-3" id="period" buttons button-variant="outline-secondary" v-model="period" name="period" @input="reload">
            <b-form-radio class="mx-0" value="H">H</b-form-radio>
            <b-form-radio class="mx-0" value="D">D</b-form-radio>
            <b-form-radio class="mx-0" value="M">M</b-form-radio>
        </b-form-radio-group>
    </b-button-toolbar>

</div>
</template>

<script>
import PlotTraffic from '../graphs/PlotTraffic'
import TabulateTraffic from '../graphs/TabulateTraffic'

export default {
    components: {
        'plottraffic': PlotTraffic,
        'tabulatetraffic': TabulateTraffic,
    },
    props: {
        interface: '',
        deviceID: '',
        device: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            period: 'D',
            myKey: 0,
            showgraph: true,
            showtable: false,

        }
    },
    methods: {
        reload() {
            this.myKey += 1;
        },
    },

}
</script>
